import { Component, ContentChildren, forwardRef, Input, OnInit, QueryList } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RADIO_GROUP, RadioButtonComponent, RadioGroup } from './radio-button/radio-button.component';

export const RADIO_GROUP_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioGroupComponent),
  multi: true
};

@Component({
  selector: 'gcc-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss'],
  providers: [
    RADIO_GROUP_CONTROL_VALUE_ACCESSOR,
    {
      provide: RADIO_GROUP,
      useExisting: RadioGroupComponent
    }
  ],
  standalone: false
})
export class RadioGroupComponent implements RadioGroup, ControlValueAccessor, OnInit {
  @ContentChildren(forwardRef(() => RadioButtonComponent), { descendants: true })
  public radios: QueryList<RadioButtonComponent>;

  @Input()
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
    this._updateRadioButtonNames();
  }

  public disabled = false;
  public value: any = null;

  private _name: any = null;

  public ngOnInit() {
    this.setDisabledState(this.disabled);
  }

  public writeValue(value: any): void {
    this.value = value;
  }

  public registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    if (this.radios) {
      this.radios.forEach(radio => {
        radio.setDisabled(isDisabled);
      });
    }
  }

  public onChange: (value: any) => void = () => {};

  public onTouched = () => {};

  private _updateRadioButtonNames(): void {
    if (this.radios) {
      this.radios.forEach(radio => {
        radio.name = this.name;
        radio.markForCheck();
      });
    }
  }
}
